/// <amd-module name="Tfs/Charting/ChartConstants" />

export class ChartGroup {
    public static current: string = "Current";
    public static historical: string = "Historical";
}

export class ChartTypes {
    public static pieChart: string = "PieChart";
    public static barChart: string = "BarChart";
    public static stackBarChart: string = "stackBarChart";
    public static columnChart: string = "ColumnChart";
    public static pivotTable: string = "PivotTable";
    public static stackAreaChart: string = "StackAreaChart";
    public static areaChart: string = "AreaChart";
    public static lineChart: string = "LineChart";
}